<template>
    <div class="program-detail-card mb-4">
        <p class="cards-title">goal</p>
        <p v-html="goal" class="card-text "></p>
        <p v-if="description" class="cards-title">description</p>
        <p v-if="description" class="mb-3" v-html="description"></p>
    </div>
</template>
<script setup lang="ts">
import {defineProps} from 'vue';

defineProps<{
    goal: string
    description?: string
}>()
</script>
